"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DispensingAnalytics = void 0;
require("ag-grid-community/dist/styles/ag-grid.css");
require("ag-grid-community/dist/styles/ag-theme-balham.css");
const ag_grid_react_1 = require("ag-grid-react");
const ui_1 = require("client/components/ui");
const dispensing_analytics_header_1 = require("client/modules/reporting/modules/reporting-list/components/report-container/dispense-report/components/dispensing-analytics-header");
const store_1 = require("client/modules/reporting/store");
const mobx_react_1 = require("mobx-react");
const React = require("react");
const no_data_found_1 = require("../no-data-found/no-data-found");
const number_formatter_1 = require("../claim-analytics/number-formatter");
require("./dispense-report.less");
let DispensingAnalytics = class DispensingAnalytics extends React.Component {
    constructor(props) {
        super(props);
        this.onButtonExport = () => {
            const params = {
                fileName: "Claim_Analytics.csv"
            };
            this.storeData.gridApi.exportDataAsCsv(params);
        };
        this.storeData = {
            defaultColDef: {
                enablePivot: true,
                enableRowGroup: true,
                enableValue: true,
                sortable: true,
                resizable: true,
                filter: true,
                comparator(a, b) {
                    if (typeof a === "string") {
                        return a.localeCompare(b);
                    }
                    else {
                        return a > b ? 1 : a < b ? -1 : 0;
                    }
                }
            },
            columnDefs: [
                // {
                //   headerName: "Patient Name",
                //   field: "Patient Name",
                //   filter: "agTextColumnFilter",
                //   // checkboxSelection: true
                //   // rowGroup: true,
                //   enableRowGroup: true
                // },
                {
                    headerName: "Pharmacy",
                    field: "Pharmacy",
                    enableRowGroup: true
                },
                {
                    headerName: "Date of Service",
                    field: "Date of Service",
                    filter: "agDateColumnFilter",
                    filterParams: {
                        comparator: (filterLocalDateAtMidnight, cellValue) => {
                            const dateAsString = cellValue;
                            if (dateAsString === null)
                                return -1;
                            const dateParts = dateAsString.split("/");
                            const cellDate = new Date(Number(dateParts[2]), Number(dateParts[0]) - 1, Number(dateParts[1]));
                            if (filterLocalDateAtMidnight.getTime() === cellDate.getTime()) {
                                return 0;
                            }
                            if (cellDate < filterLocalDateAtMidnight) {
                                return -1;
                            }
                            if (cellDate > filterLocalDateAtMidnight) {
                                return 1;
                            }
                        },
                        browserDatePicker: true
                    }
                },
                {
                    headerName: "Med Name",
                    field: "Med Name",
                    enableRowGroup: true
                },
                {
                    headerName: "NDC #",
                    field: "NDC #",
                    filter: "agTextColumnFilter"
                },
                {
                    headerName: "Reason Canceled",
                    field: "Reason Canceled",
                    filter: "agTextColumnFilter"
                }
                // {
                //   headerName: "RX #",
                //   field: "RX #"
                // },
                // {
                //   headerName: "Payment Method",
                //   field: "Payment Method"
                // },
                // {
                //   headerName: "AWP",
                //   field: "AWP",
                //   filter: "agNumberColumnFilter",
                //   type: "numericColumn",
                //   /* specify custom cell renderer */
                //   cellRenderer: "numberFormatter"
                // },
                // {
                //   headerName: "Insurance Amount",
                //   field: "Insurance Amount",
                //   filter: "agNumberColumnFilter",
                //   type: "numericColumn",
                //   /* specify custom cell renderer */
                //   cellRenderer: "numberFormatter"
                // },
                // {
                //   headerName: "Copay Amount",
                //   field: "Copay Amount",
                //   filter: "agNumberColumnFilter",
                //   type: "numericColumn",
                //   /* specify custom cell renderer */
                //   cellRenderer: "numberFormatter"
                // },
                // {
                //   headerName: "Dispense Fee",
                //   field: "Dispense Fee",
                //   type: "numericColumn",
                //   filter: "agNumberColumnFilter",
                //   /* specify custom cell renderer */
                //   cellRenderer: "numberFormatter"
                // },
                // {
                //   headerName: "Service Fee %",
                //   field: "Service Fee %",
                //   type: "numericColumn",
                //   filter: "agNumberColumnFilter"
                // },
                // {
                //   headerName: "Service Fee",
                //   field: "Service Fee",
                //   type: "numericColumn",
                //   filter: "agNumberColumnFilter",
                //   /* specify custom cell renderer */
                //   cellRenderer: "numberFormatter"
                // },
                // {
                //   headerName: "Product Unit Cost",
                //   field: "Product Unit Cost",
                //   type: "numericColumn",
                //   filter: "agNumberColumnFilter",
                //   /* specify custom cell renderer */
                //   cellRenderer: "numberFormatter"
                // },
                // {
                //   headerName: "Product Cost",
                //   field: "Product Cost",
                //   filter: "agNumberColumnFilter",
                //   type: "numericColumn",
                //   /* specify custom cell renderer */
                //   cellRenderer: "numberFormatter"
                // },
                // {
                //   headerName: "Dispensing Reimbursement",
                //   field: "Dispensing Reimbursement",
                //   filter: "agNumberColumnFilter",
                //   type: "numericColumn",
                //   /* specify custom cell renderer */
                //   cellRenderer: "numberFormatter"
                // },
                // {
                //   headerName: "Net Reimbursement",
                //   field: "Net Reimbursement",
                //   filter: "agNumberColumnFilter",
                //   type: "numericColumn",
                //   /* specify custom cell renderer */
                //   cellRenderer: "numberFormatter"
                // },
                // {
                //   headerName: "Med Name",
                //   field: "Med Name"
                // },
                // {
                //   headerName: "NDC #",
                //   field: "NDC #"
                // },
                // {
                //   headerName: "Quantity Dispensed",
                //   field: "Quantity Dispensed"
                // },
                // {
                //   headerName: "Patient Bin",
                //   field: "Patient Bin"
                // },
                // {
                //   headerName: "Patient PCN",
                //   field: "Patient PCN"
                // },
                // {
                //   headerName: "Group Id",
                //   field: "Group Id"
                // },
                // {
                //   headerName: "Patient Birth Date",
                //   field: "Patient Birth Date"
                // },
                // {
                //   headerName: "Claim Status",
                //   field: "Claim Status"
                // },
                // {
                //   headerName: "Error Message",
                //   field: "Error Message",
                //   filter: true
                // },
                // {
                //   headerName: "Provider Name",
                //   field: "Provider Name"
                // },
                // {
                //   headerName: "Portal User",
                //   field: "Portal User"
                // }
            ],
            rowSelection: "single",
            rowData: [],
            multiSortKey: "ctrl",
            floatingFilter: true,
            frameworkComponents: {
                numberFormatter: number_formatter_1.NumberFormatter
            }
        };
    }
    async componentDidMount() {
        await store_1.reportsStore.loadDispenseReport();
    }
    componentWillUnmount() {
        store_1.reportsStore.dispenseReportData = null;
    }
    render() {
        const storeData = store_1.reportsStore.dispenseReportData;
        this.storeData.rowData = storeData;
        const loadingData = store_1.reportsStore.showLoader;
        if (storeData && storeData.length > 0) {
            return (React.createElement(React.Fragment, null,
                React.createElement(dispensing_analytics_header_1.DispensingAnalyticsHeader, { title: "Dispensing Analytics", withDatePicker: true }),
                React.createElement("div", { className: "ag-theme-balham", style: {
                        height: "85%",
                        width: "100%"
                    } },
                    React.createElement("button", { onClick: this.onButtonExport.bind(this) }, "Export to CSV"),
                    React.createElement(ag_grid_react_1.AgGridReact, { onGridReady: params => (this.storeData.gridApi = params.api), rowSelection: this.storeData.rowSelection, columnDefs: this.storeData.columnDefs, defaultColDef: this.storeData.defaultColDef, frameworkComponents: this.storeData.frameworkComponents, multiSortKey: this.storeData.multiSortKey, animateRows: true, sideBar: true, groupMultiAutoColumn: true, floatingFilter: this.storeData.floatingFilter, suppressExcelExport: true, rowData: this.storeData.rowData }))));
        }
        if (storeData) {
            if (loadingData) {
                return (React.createElement(React.Fragment, null,
                    React.createElement(dispensing_analytics_header_1.DispensingAnalyticsHeader, { title: "Dispensing Analytics", withDatePicker: true }),
                    React.createElement("div", null, "Loading Data...")));
            }
            // Return a Custom built component here to handle 0 data returned.
            return (React.createElement(no_data_found_1.default, { headerComponent: React.createElement(dispensing_analytics_header_1.DispensingAnalyticsHeader, { title: "Dispensing Analytics", withDatePicker: true }) }));
        }
        return React.createElement(ui_1.UiLoadingIndicator, null);
    }
};
DispensingAnalytics = __decorate([
    mobx_react_1.observer
], DispensingAnalytics);
exports.DispensingAnalytics = DispensingAnalytics;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/reporting/modules/reporting-list/components/report-container/dispense-report/dispense-report.tsx
// module id = 3897
// module chunks = 0